// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

// Justification: all values here come from generated code and are covered by a unit-test.
/* eslint-disable security/detect-non-literal-regexp */
/* eslint-disable @typescript-eslint/no-non-null-assertion */

import { EnumMapper, SequenceMapper } from '@azure/core-client';
import * as Mappers from '../generated/models/mappers';
import * as Parameters from '../generated/models/parameters';

const course = Mappers.Course.type.modelProperties!;
const unit = Mappers.Unit.type.modelProperties!;
const contact = Mappers.Contact.type.modelProperties!;
const lessonPartProgress = Mappers.LessonPartProgress.type.modelProperties!;
const redirectUrl = Parameters.redirectUrl;
const state = Parameters.state;
const codeVerifier = Parameters.codeVerifier;
const codeChallenge = Parameters.codeChallenge;
const otacParameter = Parameters.otac;
const linkIdParameter = Parameters.linkId;
const educatorResource = Mappers.EducatorResource.type.modelProperties!;
const glossaryTerm = Mappers.GlossaryTerm.type.modelProperties!;
const curriculum = Mappers.Curriculum.type.modelProperties!;

export const uniqueId = unit.id!.constraints!;
export const uniqueIdPart = course.id!.constraints!;
export const locale = unit.locale!.constraints!;
export const title = unit.title!.constraints!;
export const description = unit.description!.constraints!;
export const descriptionRegex = new RegExp(description.Pattern!.source, 'm');
export const order = unit.order!.constraints!;
export const duration = unit.duration!.constraints!;
export const displayName = contact.displayName!.constraints!;
export const email = contact.email!.constraints!;
export const url = contact.homePage!.constraints!;
export const absoluteUrl = redirectUrl.mapper.constraints!;
export const percentage = lessonPartProgress.percentComplete!.constraints!;
export const profileName = course.profileName!.constraints!;
export const appName = Parameters.appName.mapper.constraints!;
export const appFilePath = Parameters.appFilePath.mapper.constraints!;
export const jwt = state.mapper.constraints!;
export const uuid = codeVerifier.mapper.constraints!;
export const base64UrlSha256 = codeChallenge.mapper.constraints!;
export const otac = otacParameter.mapper.constraints!;
export const sharedLinkId = linkIdParameter.mapper.constraints!;
export const mimeType = educatorResource.type!.constraints!;
export const glossaryTermName = glossaryTerm.term!.constraints!;
export const glossaryTermDefinition = glossaryTerm.definition!.constraints!;
export const tags = curriculum.tags!.constraints!;
export const tagName = (curriculum.tags! as SequenceMapper).type.element!.constraints!;

export const difficultyLevel = (Mappers.LessonPart.type.modelProperties!.level as EnumMapper).type.allowedValues;
export const editorType = (Mappers.EditorSettings.type.modelProperties!.type as EnumMapper).type.allowedValues;
export const terminalType = (Mappers.TerminalSettings.type.modelProperties!.type as EnumMapper).type.allowedValues;
export const questionType = (Mappers.Question.type.modelProperties!.type as EnumMapper).type.allowedValues;
export const authProvider = (Parameters.authProvider.mapper as EnumMapper).type.allowedValues;
export const courseType = (Mappers.Curriculum.type.modelProperties!.type as EnumMapper).type.allowedValues;
export const coursePlatform = (Mappers.Curriculum.type.modelProperties!.platform as EnumMapper).type.allowedValues;
export const abuseCategory = (Mappers.UserContentReport.type.modelProperties!.abuseCategory as EnumMapper).type
    .allowedValues;
export const reason = Mappers.UserContentReport.type.modelProperties!.reason!.constraints!;
export const reporterName = Mappers.UserContentReport.type.modelProperties!.reporterName!.constraints!;
export const promptText = Mappers.PromptRequest.type.modelProperties!.text!.constraints!;
